import { NavigateFunction } from "react-router-dom";
import { TRecommendation } from "@/infrastructure/adapters/study";
import { AppRoutes } from "@/routes/config";

/** Action type to highlight after scrolling to a level */
export type THighlightAction = "practice" | "quiz";

/** Navigation state passed to SubjectContentPage for scroll + highlight */
export type TRecommendationScrollState = {
  scrollToLevel: string;
  highlightAction: THighlightAction;
};

/** Map recommendation type to highlight action */
const getHighlightAction = (type: string): THighlightAction | null => {
  switch (type) {
    case "LEVEL_PRACTICE":
      return "practice";
    case "LEVEL_QUIZ":
      return "quiz";
    default:
      return null;
  }
};

/**
 * Navigate based on recommendation type.
 * - LEVEL_PRACTICE / LEVEL_QUIZ → go to contents page, scroll to level & highlight button
 * - ASSESSMENT → go to subject page
 */
export const navigateToRecommendation = (navigate: NavigateFunction, rec: Pick<TRecommendation, "publishedSubjectId" | "level" | "type">): void => {
  const subjectId = String(rec.publishedSubjectId);
  const highlightAction = getHighlightAction(rec.type);

  if (highlightAction && rec.level) {
    navigate(`/study/${subjectId}/contents`, {
      state: {
        scrollToLevel: rec.level,
        highlightAction,
      } satisfies TRecommendationScrollState,
    });
    return;
  }

  switch (rec.type) {
    case "ASSESSMENT":
      navigate(`/study/${subjectId}`);
      return;
    case "MOCK_EXAM":
      navigate(AppRoutes.mockExam);
      return;
    default:
      navigate(`/study/${subjectId}/contents`);
  }
};
